import { ErrorBoundary as DatadogErrorBoundary } from "@datadog/browser-rum-react";

interface FallbackProps {
  error: Error;
  resetError: () => void;
}

type Fallback = React.ComponentType<FallbackProps>;

interface SharedErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: Fallback;
}

export const DefaultFallback = ({ error }: FallbackProps): React.ReactNode => (
  <div>
    <h1>Something went wrong</h1>
    <pre>{error.message}</pre>
  </div>
);

export const ErrorBoundary = ({
  children,
  fallback,
}: SharedErrorBoundaryProps): React.ReactNode => (
  <DatadogErrorBoundary fallback={fallback || DefaultFallback}>
    {children}
  </DatadogErrorBoundary>
);
